import { Listbox, Option } from "@angular/aria/listbox";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { Combobox, ComboboxInput, ComboboxPopupContainer } from '@angular/aria/combobox';
import { switchMap, of, filter, from, Observable, OperatorFunction } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { CommonModule, AsyncPipe } from '@angular/common';
import {
  afterRenderEffect,
  effect,
  ChangeDetectionStrategy,
  Directive,
  computed,
  signal,
  viewChild,
  viewChildren, Input, Output, EventEmitter
} from '@angular/core';
@Directive({
  standalone: true,
  // Beachte: Kein Selector notwendig, wenn sie nur als Basis dient
})
export abstract class SearchAndSelectDropDownBase<T> {
  Client: RestClient = new RestClient();

  Data: T[] = [];

  @Input() selection: T | null = null;

  // MUST be named exactly 'addressChange' for [(address)] to work
  @Output() selectionChange = new EventEmitter<T | null>();

  protected abstract Serach(querry: string): T[];
  protected abstract LoadData(): Promise<T[]>;


  async LoadDataOnInit() {
    this.Data = await this.LoadData();
  }

  Items: OperatorFunction<string, T[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map((term) =>
        term === '' ? [] : this.Serach(term).slice(0, 10),
      ),
    );

  abstract formatter: (obj: T) => string;

  constructor() {

    this.LoadDataOnInit();

   
  }
   
}


